import { callApiToServer } from "../callApi";

export async function addBulkUser(Token, file, fileName) {
  console.log("Calling addBulkUser...");

  try {
    let header = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };

    console.log("Auth Token:", Token);

    let endUrl = "v1/auth/admin/add-bulk-user";
    console.log("endUrl printed here", endUrl);

    let body = JSON.stringify({ file: fileName });

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    console.error("Error in addBulkUser:", err);
    throw err;
  }
}

